import React from "react";

const CategoryVarietyCard2 = ({Image,Content}) => {
  return (
    <div>
      <div className="flex w-full items-center  rounded-sm border border-transparent border-b-gray-400 ">
        <div className="p-2 basis-2/12">
          <img src={Image} alt="" />
        </div>
        <div className=" p-2 flex-grow ">
            <a href="/">
            <h1 className="text-md font-semibold md:font-bold">Fruites & Vegitables</h1>
          <div className=" w-full hidden flex-wrap tablet:flex py-1 font-medium text-gray-600 text-sm ">
            {Content.map((curElem,index)=>{
                return (
                    <h1 key={index} className="px-1 hover:text-rose-500 ">
                         <a href="" className="block w-full">
                           {curElem}
                         </a>
                    </h1>
                )
            })}     
          </div>
            </a>
          

        </div>
      </div>
    </div>
  );
};

export default CategoryVarietyCard2;
